(() => {
  function initialise(root) {
    if (root.dataset.partnerReady) return;
    const form = root.querySelector('form');
    const steps = [...root.querySelectorAll('[data-partner-step]')];
    if (!form || steps.length !== 3) return;
    const back = root.querySelector('[data-partner-back]');
    const next = root.querySelector('[data-partner-next]');
    const submit = root.querySelector('[data-partner-submit]');
    const progress = root.querySelector('[data-partner-progress]');
    const status = root.querySelector('[data-partner-status]');
    const summary = root.querySelector('[data-partner-summary]');
    const updateSummary = () => {
      if (!summary) return;
      summary.replaceChildren();
      steps.slice(0, 2).forEach(step => {
        step.querySelectorAll('input,select,textarea').forEach(field => {
          if (!field.value.trim()) return;
          const row = document.createElement('div');
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = field.closest('label').firstChild.textContent.trim().replace(/\s*\*$/, '');
          value.textContent = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
          row.append(label, value);
          summary.append(row);
        });
      });
      summary.hidden = false;
    };
    let current = 0;
    const render = (focus = true) => {
      steps.forEach((step, index) => { step.hidden = index !== current; });
      back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      progress.hidden = false;
      progress.querySelector('progress').value = current + 1;
      status.textContent = steps[current].querySelector('legend').textContent;
      if (current === steps.length - 1) updateSummary();
      if (focus) steps[current].querySelector('legend').focus();
    };
    const validate = index => {
      const invalid = [...steps[index].querySelectorAll('input,select,textarea')].find(field => !field.checkValidity());
      if (!invalid) return true;
      current = index;
      render(false);
      const disclosure = invalid.closest('details');
      if (disclosure) disclosure.open = true;
      invalid.reportValidity();
      return false;
    };
    next.addEventListener('click', () => { if (validate(current)) { current++; render(); } });
    back.addEventListener('click', () => { if (current > 0) { current--; render(); } });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.tagName === 'INPUT' && current < steps.length - 1) {
        event.preventDefault();
        next.click();
      }
    });
    form.addEventListener('submit', event => {
      if (current < steps.length - 1) {
        event.preventDefault();
        next.click();
        return;
      }
      for (let index = 0; index < steps.length; index++) {
        if (!validate(index)) { event.preventDefault(); return; }
      }
    });
    // Keep native constraint validation ahead of Shopify's contact/captcha handlers.
    // Reveal the relevant step before the browser focuses an invalid control.
    form.addEventListener('invalid', event => {
      const index = steps.findIndex(step => step.contains(event.target));
      if (index >= 0) { current = index; render(false); }
      const disclosure = event.target.closest('details');
      if (disclosure) disclosure.open = true;
    }, true);
    root.dataset.partnerReady = 'true';
    render(false);
  }
  document.querySelectorAll('[data-partner-journey]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-partner-journey]').forEach(initialise));
})();
